// custom typeface
import "./src/components/fonts.css";

// Lors d'une navigation entre pages, Gatsby remonte en haut avec une animation
// (scroll-behavior: smooth, défini par Bootstrap). Lors d'un retour arrière, on
// restaure la position sauvegardée. Les ancres (#hash) gardent le comportement
// par défaut de Gatsby.
//
// Sur les longues pages, l'animation peut être annulée ou écrasée (la nouvelle
// page s'affiche à l'ancienne position, focus posé par le routeur, etc.) et la
// page reste alors bloquée près du footer. On surveille donc l'animation et on la
// relance tant qu'elle ne progresse pas, sauf si l'utilisateur reprend la main.
let isPopNavigation = false;
let userInteracted = false;
let scrollGuardId = 0;

const GUARD_DURATION = 3000;
const STALLED_FRAMES = 4;

const scrollSmoothlyTo = (top) => {
  const id = ++scrollGuardId;
  const start = performance.now();
  let lastDistance = Math.abs(window.scrollY - top);
  let stalledFrames = 0;
  userInteracted = false;

  window.scrollTo({ top, behavior: "smooth" });

  const check = () => {
    if (id !== scrollGuardId || userInteracted) return;
    if (performance.now() - start > GUARD_DURATION) return;

    const distance = Math.abs(window.scrollY - top);
    if (distance < 1) return;

    stalledFrames = distance < lastDistance ? 0 : stalledFrames + 1;
    lastDistance = distance;

    if (stalledFrames >= STALLED_FRAMES) {
      stalledFrames = 0;
      window.scrollTo({ top, behavior: "smooth" });
    }
    requestAnimationFrame(check);
  };
  requestAnimationFrame(check);
};

if (typeof window !== "undefined") {
  window.addEventListener("popstate", () => {
    isPopNavigation = true;
  });

  ["wheel", "touchstart", "keydown", "mousedown"].forEach((eventName) => {
    window.addEventListener(
      eventName,
      () => {
        userInteracted = true;
      },
      { passive: true, capture: true },
    );
  });
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const wasPop = isPopNavigation;
  isPopNavigation = false;

  if (location.hash) return true;

  const [, savedY] = getSavedScrollPosition(location);
  scrollSmoothlyTo(wasPop && savedY ? savedY : 0);
  return false;
};
